/* eslint-disable no-unused-expressions */

import clsx from 'clsx';
import React from 'react';
import SingleBranchLoadable from './SingleBranchLoadable';

const greenIcon = '/-/media/Project/FAB2/Fab2/data/media/svgs/icons/icon-location-pin-green';
const redIcon = '/-/media/Project/FAB2/Fab2/data/media/svgs/icons/icon-location-pin-red';
const blueIcon = '/-/media/Project/FAB2/Fab2/data/media/svgs/icons/icon-location-pin-blue';
const userIcon = '/-/media/Project/FAB2/Fab2/data/media/svgs/icons/icon-user-location';

const SingleLocationPin = ({
  lat,
  lng,
  data,
  index,
  setSelectedMapCard,
  selectedMapCard,
  dataCard,
  fields,
  t,
  justPin = false,
  setSelectedLocationCard,
  setLeftSideComponentToggle,
  setMapZoom,
  setMapCenter,
  selectedMobileLocationCard,
  setSelectedMobileLocationCard,
  swiperRef,
  params,
  i18n,
}) => {
  const renderPin = (justPin = false) => {
    if (!lat && !lng) return null;
    let isBranch = false;
    let isAtm = false;
    let isDeposit = false;
    data?.fields?.branchServices?.map((item) => {
      const title = item?.fields?.branchType?.value?.toLowerCase();
      if (title === 'branches') {
        isBranch = true;
      } else if (title === 'atm') {
        isAtm = true;
      } else if (title === 'cash deposits') {
        isDeposit = true;
      }
    });
    if (isBranch || (isBranch && isAtm)) {
      return (
        <img
          className={clsx(
            'pin-icon',
            selectedMobileLocationCard === index && 'pin-icon-mobile_selected'
          )}
          src={blueIcon}
          alt="pin"
        />
      );
    } else if (isAtm || (isAtm && isDeposit)) {
      return (
        <img
          className={clsx(
            'pin-icon',
            selectedMobileLocationCard === index && 'pin-icon-mobile_selected'
          )}
          src={greenIcon}
          alt="pin"
        />
      );
    } else if (isDeposit) {
      return (
        <img
          className={clsx(
            'pin-icon',
            selectedMobileLocationCard === index && 'pin-icon-mobile_selected'
          )}
          src={redIcon}
          alt="pin"
        />
      );
    } else if (justPin) {
      return (
        <img
          className={clsx(
            'pin-icon',
            selectedMobileLocationCard === index && 'pin-icon-mobile_selected'
          )}
          src={userIcon}
          alt="pin"
        />
      );
    } else {
      return (
        <img
          className={clsx(
            'pin-icon',
            selectedMobileLocationCard === index && 'pin-icon-mobile_selected'
          )}
          src={redIcon}
          alt="pin"
        />
      );
    }
  };

  const pinClick = (e) => {
    if (justPin) return;
    setSelectedMapCard(index);
    setMapZoom(14);
    if (data?.fields?.longitude?.value && data?.fields?.latitude?.value) {
      setMapCenter({
        lat: data.fields.latitude.value,
        lng: data.fields.longitude.value,
      });
    }
    e.stopPropagation();
  };
  const pinClickMobile = (e) => {
    if (justPin) return;
    setMapZoom(16);
    swiperRef.current.swiper.slideTo(index);
    setSelectedMobileLocationCard(index);
    if (data?.fields?.longitude?.value && data?.fields?.latitude?.value) {
      setMapCenter({
        lat: data.fields.latitude.value,
        lng: data.fields.longitude.value,
      });
    }
    e.stopPropagation();
  };

  return (
    <div className="single-pin">
      <div onClick={pinClick} className="single-pin--overlay"></div>
      <div onClick={pinClickMobile} className="single-pin-mobile--overlay"></div>
      {!justPin && selectedMapCard !== -1 && index === selectedMapCard && (
        <>
          <div className="map-card">
            <div className="relative-map-card">
              <SingleBranchLoadable
                t={t}
                data={dataCard}
                mapCard
                fields={fields}
                index={index}
                setSelectedLocationCard={setSelectedLocationCard}
                setLeftSideComponentToggle={setLeftSideComponentToggle}
                params={params}
                i18n={i18n}
              />
            </div>
          </div>
        </>
      )}
      {renderPin(justPin)}
    </div>
  );
};

export default SingleLocationPin;
